<div class="modal">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">
    <mat-icon class="back" (click)="openPreSales1Modal()"
      >arrow_back_ios</mat-icon
    >{{ data?.name }}
  </div>
  <div class="detail" mat-dialog-content>
    <div class="part">
      您是不是想了解这些
      <span (click)="changePage()"><mat-icon>sync</mat-icon> 换一批</span>
    </div>
    <mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
    <div class="part-main">
      <div
        class="item"
        matRipple
        *ngFor="let item of articles"
        [routerLink]="
          '/helping/detail/' +
          item.tag_id +
          '/p/' +
          page +
          '/article/' +
          item.id
        "
      >
        {{ item.title }}
      </div>
    </div>
    <div class="part">没有解决我的疑问</div>
    <div class="part-main flex">
      <div class="item" matRipple (click)="showCustomerService()">
        咨询AI客服
      </div>
      <div class="item" matRipple [routerLink]="'/helping'">
        查看全部帮助文章
      </div>
    </div>
    <div class="part">没疑问啦</div>
    <div class="part-main">
      <div class="item" (click)="purchase()" matRipple>购买上车</div>
    </div>
  </div>
</div>
